<template>
  <div class="main-layout min-h-screen flex flex-col relative" :class="backgroundColor">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'NoneLayout',

  components: {
  },

  data: function () {
    return {

    }
  },
  
  computed: {
    backgroundColor() {
      return this.$route.meta?.backgroundColor || 'bg-moone-pink'
    }
  },
  
  mounted () {
  },

  methods: {}
}
</script>
